import React, { useEffect, useState } from "react";
import { isUsableAvatarUrl } from "../../../utils/communityHub";

const AVATAR_COLORS = [
  "#15415E",
  "#1E596D",
  "#122F46",
  "#183852",
  "#2D7D9A",
  "#0E4D6B",
];

function getAvatarColor(name: string) {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

export { isUsableAvatarUrl } from "../../../utils/communityHub";

function InitialsAvatar({
  initials,
  name,
  size,
}: {
  initials: string;
  name: string;
  size: number;
}) {
  return (
    <div
      className="rounded-full text-white font-bold grid place-items-center shrink-0"
      style={{
        width: size,
        height: size,
        background: getAvatarColor(name),
        fontSize: size * 0.38,
      }}
      aria-hidden
    >
      {initials}
    </div>
  );
}

export default function CommunityAvatar({
  initials,
  name,
  avatarUrl,
  size = 40,
}: {
  initials: string;
  name: string;
  avatarUrl?: string;
  size?: number;
}) {
  const [imageFailed, setImageFailed] = useState(false);
  const trimmedUrl = (avatarUrl || "").trim();
  const canShowImage = isUsableAvatarUrl(trimmedUrl) && !imageFailed;

  useEffect(() => {
    setImageFailed(false);
  }, [trimmedUrl]);

  if (canShowImage) {
    return (
      <img
        src={trimmedUrl}
        alt=""
        className="rounded-full object-cover shrink-0"
        style={{ width: size, height: size }}
        onError={() => setImageFailed(true)}
      />
    );
  }

  return (
    <InitialsAvatar initials={initials} name={name} size={size} />
  );
}
